(function(){
"use strict";

angular.module("swapick")
.factory('SwapService', SwapService);

function SwapService($q, DataService, Categories, $ionicPopup){
  var svc = {}

  
  svc.getSwapData = (yourObjectId) =>{

    return Categories
      .getCategories()
      .then(categories => {
        let categoriesData = Categories.data;
        return categoriesData
      })
      .then(categoriesData=> {
        return DataService
          .items
          .one(yourObjectId)
          .get()
          .then(resp => {
              let obj = resp;
              let yourObject = obj;
              let you = obj.posseduto_da[0];
              return { yourObject:obj, you:you, categoriesData:categoriesData }
          })
      })
      .then(data=> {
            let obj = data.yourObject;
            return DataService
            .itemsIcanGive
            .get({ swapper_id:obj.posseduto_da[0].user.id })
            .then(itemsIcan => {
              data.numSwappables = itemsIcan.total_items;
              //data.itemsIcan = itemsIcan;
              return data;
            })

      })
  }



  svc.getUserNumSwapData = (userId) =>{

    return DataService
      .itemsIcanGive
      .get({ swapper_id:userId })
      .then(itemsIcan => {
        return {numSwappables : itemsIcan.total_items};
      })
  }





  svc.loadCandidatesPage = (offset, swapper_id) => {
    if(this.svc){
      console.error("loading already")
      return $q.when(false).promise;
    }
    svc.loadingCandidates = true;

    //call again dataservice and push to the list
    return DataService.itemsIcanGive.get(
      { limit:50, offset: offset,
        swapper_id:swapper_id
      }
    )
    .then(resp => {
      let items = resp.items;
      items = _.map(items, i=>{ let p = i.posseduto_da;
        i.posseduto_da = [p]; return i; })
      let objs =items;

      return { resp:resp, objs:objs};
    })
    .finally(()=>{
      svc.loadingCandidates = false;
    })
  }


  return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/swap-service.js